// extracted by mini-css-extract-plugin
module.exports = {"formBody":"ProductCreation_formBody__3ILzK","pictures":"ProductCreation_pictures__1xLcT"};